<template>
  <div class="login-wrap">
    <video @click="playVideo()" v-if="isVedio" class="videoUrlImg bg" ref="video" :src="videoUrl" :poster="(videoUrl!=''?videoUrl:'')" controls autoplay=true ></video>
    <div class="productLeft">
      <!-- 左侧中图  -->      
      <div class="mdImg">
        <!-- <img :src="`${qall}`" alt="" /> -->
        <el-image v-if="!isVedio" :src="`${qall}`" alt="" class="bg">
            <div slot="error" class="image-slot  bg-font-size-big">
              <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>
      </div>
      <!-- 遮罩层  -->
      <div
        v-show="isShow&(isVedio==false)"
        class="marks"
        :style="{ top: top + 'px', left: left + 'px' }"
      ></div>
      <!-- 遮罩层 玻璃板 superMarks -->
      <div
        v-if="isPC == false"
        @touchstart.prevent="enter"
        @touchend.prevent="leave"
        @touchmove.prevent="marks"
        class="superMarks"
      ></div>

      <div
        v-if="isPC == true"
        @mouseenter="enter"
        @mouseleave="leave"
        @mousemove="marks"
        class="superMarks"
      ></div>
      <!-- <div
        v-if="isPC == false"
        @touchstart.prevent="enter"
        @touchend.prevent="leave"
        @touchmove.prevent="marks"
        @click.prevent="sub()"
        class="superMarks"
      ></div>

      <div
        v-if="isPC == true"
        @mouseenter="enter"
        @mouseleave="leave"
        @mousemove="marks"
        @click.prevent="sub()"
        class="superMarks"
      ></div> -->

      <div v-show="isShow&(isVedio==false)" class="lgImg">
        <img
          :src="`${qallBig}`"
          alt=""
          :style="{ top: topLgImg + 'px', left: leftLgImg + 'px' }"
        />
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: "blog-header",
  data() {
    return {
      isPC: true,
      // 大图片
    //   qall: require('@/assets/images/logo.png'),
    //   qallBig:require('@/assets/images/logo.png'),
      isShow: false, //控制遮罩层marks和大图片是否显示"
      left: 0, //marks左移位置
      top: 0, //marks下移位置
      leftLgImg: 0, //大图lgImg移动的位置
      topLgImg: 0, //大图lgImg移动的位置
    };
  },
  props: ['qall','qallBig','videoUrl','isVedio'],
  // watch: {
  //       isVedio: {
  //         handler () {
  //         },
  //         // 监听到数据变化时立即调用
  //         immediate: true
  //     }
  //   },
  methods: {

    playVideo(){
				// this.isPlay=true
				this.$refs.video.play()
		},
    //鼠标进入和离开
    enter() {
      this.isShow = true;
    },
    leave() {
      this.isShow = false;
    },
    //遮罩层放大镜
    marks(e) {
      var marksWidth = 48; //marks的宽
      var marksHeight = 48; //marks的高
      if (this.isPC == true) {
        //PC端
        this.left = e.offsetX - marksWidth / 2;
        this.top = e.offsetY - marksHeight / 2;
        // console.log(this.left,this.top,'高度。。。。。。。。。。。。。。。。。。。。')
        if (this.left < 0) {
          this.left = 0;
        } else if (this.left > 290) {
          this.left = 290;
        }
        if (this.top < 0) {
          this.top = 0;
        } else if (this.top > 290) {
          this.top = 290;
        }

        //大d图片除以小的图片的宽高
        this.leftLgImg = (-this.left * 880) / 440;
        this.topLgImg = (-this.top * 880) / 440;
      } else {
        //移动端
        this.left = e.changedTouches[0].clientX - marksWidth / 2;
        this.top = e.changedTouches[0].clientY - marksHeight / 2;
        if (this.left < 0) {
          this.left = 0;
        } else if (this.left > 440) {
          this.left = 440;
        }
        if (this.top < 0) {
          this.top = 0;
        } else if (this.top > 220) {
          //45就是小图片的高度的一半，91/2
          this.top = 220;
        }

        //大d图片除以小的图片的宽高
        this.leftLgImg = (-this.left * 880) / 440;
        this.topLgImg = (-this.top *880) / 440;
      }
    },
    
  },
  mounted() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.isPC = false;
    } else {
      console.log("PC端");
    }
  },
};
</script>

<style scoped lang='less'>
.login-wrap{
  .videoUrlImg{
    height: 440px; 
  }
}

/* 左侧大小图样式 160*91  320*181*/
.productLeft {
  width: 440px;
  position: relative;
}
/* 左侧中图 */
.mdImg,
.mdImg > img {
  width: 440px;
  height: 440px;
//   width: 160px;
//   height: 91px;
//   margin-left: 15px;
}
/*遮罩层superMarks */
.superMarks {
//   width: 160px;
//   height: 91px;
  width: 440px;
  height: 440px;
  background-color: rgba(220, 220, 220, 0);
  position: absolute;
  top: 0px;
  left: 0px;
}
/* 遮罩层 */
.marks {
  width: 150px;
  height: 150px;
  position: absolute;
  background-color: rgba(220, 220, 220, 0.5);
  /*top:0px;  //内联设置了动态的top，left
        left:0px;*/
}

/* 左侧隐藏大图 */
.lgImg {
//   width: 160px;
//   height: 91px;
  width: 440px;
  height: 440px;
  overflow: hidden;
  position: absolute;
  top: 0px;
  left: 440px;
  border: 2px solid #aaa;
  background-color: #fff;
  z-index: 90;
}
.lgImg img {
  width: 880px;
  height: 880px;
  position: absolute;
  /*top:100px;
        left:100px;*/
}
</style>


// WEBPACK FOOTER //
// src/components/magnifier.vue